import { render } from "./MentorHome.vue?vue&type=template&id=f0207c32"
import script from "./MentorHome.vue?vue&type=script&lang=js"
export * from "./MentorHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__